export const NAME = "Drag";
export const HAS_DRAG = true;
export const BUTTON_PANEL_SIZE = 0;
export { default as Node } from "./Node";
export { default as toPdf } from "./pdf";
export const ITEM_SIZE = { width: 150, height: 100 };